<template>
  <div>
    <CRow class="mt-3">
      <CCol sm="12">
        <CButton
            color="primary" ref="refreshBtn"
            v-c-tooltip.hover="'Tải lại'"
            class="btn-action-primary"
            @click="changeTab()"
            style="float: right;">
          <i class="fa fa-refresh"></i>&nbsp;&nbsp;Tải lại
        </CButton>
        <CButton
            color="primary"
            v-c-tooltip.hover="'Thêm mới'"
            class="btn-action-primary mr-2"
            style="float: right;" @click="clickAdd()">
          <i class="fa fa-plus"></i>&nbsp;Thêm mới
        </CButton>
        <CTabs variant="pills" :active-tab="activeTab.data.model" @update:activeTab="changeTab">
          <CTab title="Authentication Server">
            <CCard class="content-fade-in mt-3p5">
              <CCardBody>
                <BaseTable
                    :options="mainTable.options"
                    :slots="mainTable.slots"
                    :dataSource="mainTable.dataSource"
                    ref="mainTable">
                  <template #index="{index}">
                    <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
                  </template>
                  <template #urlAuthen="{item}">
                    <td>
                      <div>{{ item.urlAuthen }}</div>
                      <div class="badge badge-light">{{ item.md5Authen }}</div>
                    </td>
                  </template>
                  <template #urlSaveLog="{item}">
                    <td>
                      <div>{{ item.urlSaveLog }}</div>
                      <div class="badge badge-light">{{ item.md5SaveLog }}</div>
                    </td>
                  </template>
                  <template #action="{item, index}">
                    <td class="action-btn-group">
                      <div class="action-btn-wrapper">
                        <CButton
                            color="danger"
                            variant="outline"
                            class="ml-1"
                            square
                            size="sm"
                            v-c-tooltip.hover="'Xóa'"
                            @click="setupSelectOneAction('delete_one', index)">
                          <CIcon name="cil-trash"/>
                        </CButton>
                      </div>
                    </td>
                  </template>
                </BaseTable>
              </CCardBody>
            </CCard>
          </CTab>
          <CTab title="TURN Server">
            <CCard class="content-fade-in mt-3p5">
              <CCardBody>
                <BaseTable
                    :options="mainTableTurnServer.options"
                    :slots="mainTableTurnServer.slots"
                    :dataSource="mainTableTurnServer.dataSource"
                    ref="mainTableTurnServer">
                  <template #index="{index}">
                    <td>{{ $refs.mainTableTurnServer.getTotalElementByPage + index }}</td>
                  </template>
                  <template #key="{item}">
                    <td>
                      <span style="font-weight: 550;">{{ item.key }}</span>
                    </td>
                  </template>
                  <template #values="{item}">
                    <td>
                      <template v-for="each in item.values ">
                        <span style="font-weight: 550;">{{ each }}</span>
                        <br/>
                      </template>
                    </td>
                  </template>
                  <template #action="{item, index}">
                    <td class="action-btn-group">
                      <div class="action-btn-wrapper">
                        <CButton
                            color="danger"
                            variant="outline"
                            class="ml-1"
                            square
                            size="sm"
                            v-c-tooltip.hover="'Xóa'"
                            @click="setupSelectOneAction('delete_one', index)">
                          <CIcon name="cil-trash"/>
                        </CButton>
                      </div>
                    </td>
                  </template>
                </BaseTable>
              </CCardBody>
            </CCard>
          </CTab>
          <CTab title="STUN Server">
            <CCard class="content-fade-in mt-3p5">
              <CCardBody>
                <BaseTable
                    :options="mainTableStunServer.options"
                    :slots="mainTableStunServer.slots"
                    :dataSource="mainTableStunServer.dataSource"
                    ref="mainTableStunServer">
                  <template #index="{index}">
                    <td>{{ $refs.mainTableStunServer.getTotalElementByPage + index }}</td>
                  </template>
                  <template #key="{item}">
                    <td>
                      <span style="font-weight: 550;">{{ item.key }}</span>
                    </td>
                  </template>
                  <template #values="{item}">
                    <td>
                      <template v-for="each in item.values ">
                        <span style="font-weight: 550;">{{ each }}</span>
                        <br/>
                      </template>
                    </td>
                  </template>
                  <template #action="{item, index}">
                    <td class="action-btn-group">
                      <div class="action-btn-wrapper">
                        <CButton
                            color="danger"
                            variant="outline"
                            class="ml-1"
                            square
                            size="sm"
                            v-c-tooltip.hover="'Xóa'"
                            @click="setupSelectOneAction('delete_one', index)">
                          <CIcon name="cil-trash"/>
                        </CButton>
                      </div>
                    </td>
                  </template>
                </BaseTable>
              </CCardBody>
            </CCard>
          </CTab>
        </CTabs>
      </CCol>
    </CRow>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>

    <CModal :title="'Thêm mới cấu hình: ' + dataAddConfig.title" :show.sync="dataAddConfig.isShowModal"
            :closeOnBackdrop="false">
      <CRow class="pb-2">
        <template v-if="activeTab.data.model == 0">
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataAddConfig.authensServer.codeInput.options"
                       :data="dataAddConfig.authensServer.codeInput.data"/>
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataAddConfig.authensServer.descriptionInput.options"
                       :data="dataAddConfig.authensServer.descriptionInput.data"/>
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataAddConfig.authensServer.urlAuthenInput.options"
                       :data="dataAddConfig.authensServer.urlAuthenInput.data"/>
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataAddConfig.authensServer.urlSaveLogInput.options"
                       :data="dataAddConfig.authensServer.urlSaveLogInput.data"/>
          </CCol>
        </template>
        <template v-if="activeTab.data.model == 1">
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataAddConfig.turnsServer.serverInput.options"
                       :data="dataAddConfig.turnsServer.serverInput.data"/>
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataAddConfig.turnsServer.userInput.options"
                       :data="dataAddConfig.turnsServer.userInput.data"/>
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataAddConfig.turnsServer.credInput.options"
                       :data="dataAddConfig.turnsServer.credInput.data"/>
          </CCol>
        </template>
        <template v-if="activeTab.data.model == 2">
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataAddConfig.stunsServer.stunInput.options"
                       :data="dataAddConfig.stunsServer.stunInput.data"/>
          </CCol>
        </template>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="dataAddConfig.isShowModal = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitAddConfigAuthentication()"><i
            class="fa fa-check"></i> Thêm mới
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";

export default {
  name: "CacheList",
  components: {BaseTable, ModalConfirm, BaseInput},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    var that = this;
    var actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/constant/deleteByKey",
      isJsonContentType: false,
      titlePopup: function () {
        return that.$helper.setupTitleAction(
            "xóa",
            "phần tử thứ",
            that.actionData.model.index.toString()
        );
      },
      dataSubmit: function () {
        return {
          index: that.actionData.model.index,
          key: that.convertTabToKey()
        };
      },
      successCallback: function () {
        that.showSuccessMsg({
          message: "Cập nhật tiến trình thành công"
        });
        that.changeTab();
      }
    });

    return {
      activeTab: {
        data: {
          model: 0,
          name: 'type'
        }
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          index: null
        }
      },
      mainTable: {
        options: {
          noPaging: true,
          fields: [
            {key: "index", label: "STT"},
            {key: "code", label: "Code"},
            {key: "description", label: "Mô tả"},
            {key: "urlAuthen", label: "Authentication URI"},
            // {key: "md5Authen", label: "Authentication MD5"},
            {key: "urlSaveLog", label: "Save Log URI"},
            // {key: "md5SaveLog", label: "Save Log MD5"},
            {key: "action", label: "Thao tác"},
          ],
          slots: ["index", "urlAuthen", "urlSaveLog", "action"]
        },
        dataSource: {
          url: "/constant/getListKeyAuthenticationDeviceByKey",
          isJsonContentType: false,
          dataSubmit: function () {
            return {key: that.convertTabToKey()};
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
          btnCallAjaxs: function () {
            return [that.$refs.refreshBtn]
          },
          resultListAttrName: "response"
        }
      },
      dataAddConfig: {
        isShowModal: false,
        title: '',
        authensServer: {
          codeInput: {
            options: {
              label: "Code <span class='required'>*</span>",
              placeholder: "Code",
              type: "text",
              // append: 'N/A'
            },
            data: {
              name: "code",
              model: "",
              updateCallback: function () {
                that.submitConfigAuthentication();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataAddConfig.authensServer.codeInput.data.model;
                  if (value == '') {
                    this.isValid = false;
                    this.errorMessage = "Code không để trống";
                  } else {
                    this.isValid = true;
                    this.errorMessage = "";
                  }
                  return this.isValid;
                }
              }
            }
          },
          descriptionInput: {
            options: {
              label: "Mô tả <span class='required'>*</span>",
              placeholder: "Mô tả",
              type: "text",
              // append: 'N/A'
            },
            data: {
              name: "description",
              model: "",
              updateCallback: function () {
                that.submitConfigAuthentication();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataAddConfig.authensServer.descriptionInput.data.model;
                  if (value == '') {
                    this.isValid = false;
                    this.errorMessage = "Mô tả không để trống";
                  } else {
                    this.isValid = true;
                    this.errorMessage = "";
                  }
                  return this.isValid;
                }
              }
            }
          },
          urlAuthenInput: {
            options: {
              label: "Authentication Server URI <span class='required'>*</span>",
              placeholder: "Authentication Server URI",
              type: "text",
              // append: 'N/A'
            },
            data: {
              name: "urlAuthen",
              model: "",
              updateCallback: function () {
                that.submitConfigAuthentication();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataAddConfig.authensServer.urlAuthenInput.data.model;
                  if (value == '') {
                    this.isValid = false;
                    this.errorMessage = "Authentication Server URI không để trống";
                  } else {
                    this.isValid = true;
                    this.errorMessage = "";
                  }
                  return this.isValid;
                }
              }
            }
          },
          urlSaveLogInput: {
            options: {
              label: "Save Log URI <span class='required'>*</span>",
              placeholder: "Save Log URI",
              type: "text",
              // append: 'N/A'
            },
            data: {
              name: "urlSaveLog",
              model: "",
              updateCallback: function () {
                that.submitConfigAuthentication();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataAddConfig.authensServer.urlSaveLogInput.data.model;
                  if (value == '') {
                    this.isValid = false;
                    this.errorMessage = "Save Log URI không để trống";
                  } else {
                    this.isValid = true;
                    this.errorMessage = "";
                  }
                  return this.isValid;
                }
              }
            }
          },
        },
        turnsServer: {
          serverInput: {
            options: {
              label: "Server <span class='required'>*</span>",
              placeholder: "Server",
              type: "text",
              // append: 'N/A'
            },
            data: {
              name: "server",
              model: "",
              updateCallback: function () {
                that.submitConfigAuthentication();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataAddConfig.turnsServer.serverInput.data.model;
                  if (value == '') {
                    this.isValid = false;
                    this.errorMessage = "Server không để trống";
                  } else {
                    this.isValid = true;
                    this.errorMessage = "";
                  }
                  return this.isValid;
                }
              }
            }
          },
          userInput: {
            options: {
              label: "User <span class='required'>*</span>",
              placeholder: "User",
              type: "text",
              // append: 'N/A'
            },
            data: {
              name: "user",
              model: "",
              updateCallback: function () {
                that.submitConfigAuthentication();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataAddConfig.turnsServer.userInput.data.model;
                  if (value == '') {
                    this.isValid = false;
                    this.errorMessage = "User không để trống";
                  } else {
                    this.isValid = true;
                    this.errorMessage = "";
                  }
                  return this.isValid;
                }
              }
            }
          },
          credInput: {
            options: {
              label: "Cred <span class='required'>*</span>",
              placeholder: "Cred",
              type: "text",
              // append: 'N/A'
            },
            data: {
              name: "cred",
              model: "",
              updateCallback: function () {
                that.submitConfigAuthentication();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataAddConfig.turnsServer.credInput.data.model;
                  if (value == '') {
                    this.isValid = false;
                    this.errorMessage = "Cred không để trống";
                  } else {
                    this.isValid = true;
                    this.errorMessage = "";
                  }
                  return this.isValid;
                }
              }
            }
          },
        },
        stunsServer: {
          stunInput: {
            options: {
              label: "STUN <span class='required'>*</span>",
              placeholder: "STUN",
              type: "text",
              // append: 'N/A'
            },
            data: {
              name: "",
              model: "",
              updateCallback: function () {
                that.submitConfigAuthentication();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataAddConfig.stunsServer.stunInput.data.model;
                  if (value == '') {
                    this.isValid = false;
                    this.errorMessage = "STUN không để trống";
                  } else {
                    this.isValid = true;
                    this.errorMessage = "";
                  }
                  return this.isValid;
                }
              }
            }
          },
        },
      },
      mainTableTurnServer: {
        options: {
          noPaging: true,
          fields: [
            {key: "index", label: "STT"},
            {key: "server", label: "SERVER"},
            {key: "user", label: "User"},
            {key: "cred", label: "Cred"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["index", "key", "value", "action"],
          lazyLoad: false
        },
        dataSource: {
          url: "/constant/getListKeyAuthenticationDeviceByKey",
          isJsonContentType: false,
          dataSubmit: function () {
            return {key: that.convertTabToKey()};
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
          btnCallAjaxs: function () {
            return [that.$refs.refreshBtn]
          },
          resultListAttrName: "response"
        }
      },
      mainTableStunServer: {
        options: {
          noPaging: true,
          fields: [
            {key: "index", label: "STT"},
            {key: "server", label: "SERVER"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["index", "key", "value", "action"],
          lazyLoad: false
        },
        dataSource: {
          url: "/constant/getListKeyAuthenticationDeviceByKey",
          isJsonContentType: false,
          dataSubmit: function () {
            return {key: that.convertTabToKey()};
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
          btnCallAjaxs: function () {
            return [that.$refs.refreshBtn]
          },
          resultListAttrName: "response"
        }
      }
    };
  },
  methods: {
    setupSelectOneAction: function (actionTypeKey, index) {
      this.actionData.model.index = index;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    loadDataMainTable: function () {
      this.$refs.mainTable.loadData();
    },
    setupThreadAction: function (actionTypeKey, threadSelectedId) {
      this.actionData.model.threadSelectedId = threadSelectedId || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    changeTab(tab) {
      if (tab != null) {
        this.activeTab.data.model = tab;
      }
      if (this.activeTab.data.model == 0) {
        this.$refs.mainTable.loadData();
      } else if (this.activeTab.data.model == 1) {
        this.$refs.mainTableTurnServer.loadData();
      } else if (this.activeTab.data.model == 2) {
        this.$refs.mainTableStunServer.loadData();
      }
    },
    convertTabToKey() {
      if (this.activeTab.data.model == 0) {
        return "authentication_device_server";
      } else if (this.activeTab.data.model == 1) {
        return "turn_server";
      } else if (this.activeTab.data.model == 2) {
        return "stun_server";
      }
    },
    clickAdd() {
      this.dataAddConfig.isShowModal = true;
      this.dataAddConfig.title = this.convertTabToKey();
    },
    submitAddConfigAuthentication() {
      let that = this;
      let isValid = true;
      let dataReq = {};
      if (that.activeTab.data.model == 0) {
        isValid &= this.dataAddConfig.authensServer.codeInput.data.validator.valid();
        isValid &= this.dataAddConfig.authensServer.descriptionInput.data.validator.valid();
        isValid &= this.dataAddConfig.authensServer.urlAuthenInput.data.validator.valid();
        isValid &= this.dataAddConfig.authensServer.urlSaveLogInput.data.validator.valid();
        dataReq.authenServer = {
          code: this.dataAddConfig.authensServer.codeInput.data.model,
          description: this.dataAddConfig.authensServer.descriptionInput.data.model,
          urlAuthen: this.dataAddConfig.authensServer.urlAuthenInput.data.model,
          urlSaveLog: this.dataAddConfig.authensServer.urlSaveLogInput.data.model
        }
      } else if (that.activeTab.data.model == 1) {
        isValid &= this.dataAddConfig.turnsServer.serverInput.data.validator.valid();
        isValid &= this.dataAddConfig.turnsServer.userInput.data.validator.valid();
        isValid &= this.dataAddConfig.turnsServer.credInput.data.validator.valid();
        dataReq.turnServer = {
          server: this.dataAddConfig.turnsServer.serverInput.data.model,
          user: this.dataAddConfig.turnsServer.userInput.data.model,
          cred: this.dataAddConfig.turnsServer.credInput.data.model,
        }
      } else if (that.activeTab.data.model == 2) {
        isValid &= this.dataAddConfig.stunsServer.stunInput.data.validator.valid();
        dataReq.stunServer = this.dataAddConfig.stunsServer.stunInput.data.model;
      }
      dataReq.key = that.convertTabToKey();
      if (!isValid) {
        return;
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/constant/save",
        dataSubmit: function () {
          return dataReq;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({message: "Thêm mới cấu hình thành công"});
            that.dataAddConfig.isShowModal = false;
            that.changeTab();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  computed: {},
  beforeCreate: function () {
  },
  created: function () {
  },
  mounted() {
  },
  watch: {}
};
</script>
<style scoped></style>
